'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpikelineIcon = function SpikelineIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M32 6.438c0 3.563-2.875 6.5-6.438 6.5s-6.5-2.938-6.5-6.5C19.062 2.875 22 0 25.562 0S32 2.875 32 6.438zM11.563 8.875h5.75v-5.75h-5.75zM0 8.875h5.75v-5.75H0zM23.125 20.5h5.75v-5.813h-5.75zm0 11.5h5.75v-5.75h-5.75z' })
    );
};

exports.default = SpikelineIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/SpikelineIcon.js
// module id = 698
// module chunks = 0